<template lang="pug">
.ncons.epw-ncons.active
  .bank-detail
    .bank-detail-header {{ $t('ui.bank_detail') }}
    .bank-detail-body
      .row
        .col-5.col-lg-3.text-capitalize {{ $t('ui.account_name') }}
        .col-1.col-lg-auto :
        .col-6.col-lg-8 EpicWin
      .row
        .col-5.col-lg-3.text-capitalize {{ $t('ui.account_no') }}
        .col-1.col-lg-auto :
        .col-6.col-lg-8 {{ $t('ui.contact_for_bank') }}
  .mb-3
    label.col-form-label {{ $t('ui.operator_bank_list') }}
    select.select-image.px-2.py-2(v-model.trim="$v.bankAcc.$model")
      option(disabled="" selected="" value="") {{ $t('ui.please_select_bank') }}
      option(v-for="bank in operatorBankList" :value="bank.bank_acc_no") {{ bank.bank_name }} ({{ bank.bank_acc_holder }})
    .error.w-100(v-if="$v.bankAcc.$model == '' && $v.bankAcc.$dirty")
      small.text-danger.form-text {{ $t('ui.please_select_bank') }}
  .mb-3
    label.col-form-label {{ $t('ui.deposit_method') }}
    select.select-image.px-2.py-2(v-model.trim="$v.depositMethod.$model")
      option(disabled="" selected="" value="") {{ $t('ui.deposit_method') }}
      //- option(value="CDM") {{ $t("ui.cdm") }}
      //- option(value="ATM") {{ $t("ui.atm") }}
      //- option(value="COUNTER") {{ $t('ui.counter') }}
      option(value="ONLINE") {{ $t('ui.online') }}
    .error.w-100(v-if="$v.depositMethod.$model == '' && $v.depositMethod.$dirty")
      small.text-danger.form-text {{ $t("ui.select_deposit")}}
  .mb-3
    label.col-form-label {{ $t('ui.amount') }} ({{ $t("ui.min") }} {{ $t("ui.amount") }}:  {{ this.$store.getters.currencyCode }} {{ $numeral(minSettingDeposit).format("0,0.00") }})
    input.form-control#deposit-manual(:class="{'disable-display': promoId !== ''}" type="text" placeholder="eg. 500" v-model.trim="$v.depositAmount.$model" :disabled="promoId !== ''" )
    .error.w-100(v-if="!$v.depositAmount.required && $v.depositAmount.$dirty")
      small.text-danger.form-text {{$t('ui.deposit_enter')}}
    .error.w-100(v-if="!$v.depositAmount.minValue && $v.depositAmount.$dirty")
      small.text-danger.form-text {{$t('ui.amount_not_min')}}
  .deposit-amount-wrapper
    .row.row-cols-6
      .col
        .select-amount(@click="fillAmount(10)") 10
      .col
        .select-amount(@click="fillAmount(30)") 30
      .col
        .select-amount(@click="fillAmount(50)") 50
      .col
        .select-amount(@click="fillAmount(100)") 100
      .col
        .select-amount(@click="fillAmount(200)") 200
      .col
        .select-amount(@click="fillAmount(300)") 300
  .row
    .col-7
      div.date-container(style="position:relative;")
        label.col-form-label {{ $t('ui.date') }}
        date-picker(
          v-model="workingDate"
          :config="optionsDate"
        )
    .col-5.mb-3
      div.time-container(style="position:relative;")
        label.col-form-label {{ $t('ui.time') }}
        date-picker(
          v-model="workingTime"
          :config="optionsTime"
        )
  .mb-3
    label.col-form-label {{ $t("ui.attachment") }}
    .d-flex
      div.w-75(style="position:relative")
        input.form-control.pointer(type="text" v-model.trim="$v.imageName.$model" @click="getFile()" style="padding-right: 1.8rem")
        input.form-control.d-none#uploadFile(type="file" ref="file" @change="onSelect" )
        .errspan.fa.fa-close(v-if="imageName" @click="removeAttachment")
      button.btn-sub.btn-custom-height.btn-upload.w-25.m-0(type="button" @click="getFile()") {{ $t("ui.upload_file") }}
    //- .d-flex
      input.custom-file-input.form-control.w-75#uploadFile(type="file" ref="file" @change="onSelect")
      label.custom-file-label
        button.btn.btn-warning.ml-2.rounded-0.btn-upload(type="button" @click="triggerUpload") {{ $t("ui.upload_file") }}
    small.form-text.text-white {{ $t("ui.upload_file_tooltips") }}
  .mb-3
    label.col-form-label {{ $t("ui.reference_number") }}
    input.form-control(type="text" :placeholder="$t('ui.reference_number')" v-model.trim="$v.referenceNo.$model")
    .error.w-100(v-if="!$v.referenceNo.required && $v.referenceNo.$dirty")
      small.text-danger.form-text {{ $t("ui.reference_number_tooltips") }}
  .mb-3
    label.col-form-label {{$t('ui.select_bonus')}}:
    #accordion
      .tnc-card.bonus-card
        button.btn-tnc.collapsed(data-bs-toggle='collapse' data-bs-target='#bonusselect' aria-expanded='false' aria-controls='tnc1') {{$t('ui.select_bonus')}}
        #bonusselect.collapse(aria-labelledby='headingOne' data-bs-parent='#accordion' style='')
          .bonusselbox
            .nfwrap.epw-nfwrap
              //- .nftabs
                a.epw-nftabs.active(href='#' dd='slot') Slot
                a.epw-nftabs(href='#' dd='live') Live
                a.epw-nftabs(href='#' dd='welcome') Welcome Bonus
                a.epw-nftabs(href='#' dd='referral') Referral Bonus
              .nfcons
                template(v-for="(promo,index) in promotionList")
                  .nflist.epw-nflist.pointer(v-if="promo.promotion_id != null && promo.status ===  1" :class="{'active': promoId === promo.promotion_id}" @click="selectPromo(promo.promotion_id, promo.package_amount)")
                    input.radio.pointer(type='radio' v-model="promoId" :value="promo.promotion_id")
                    .ccon
                      .iimg
                        img(v-if="promo.bonus_rate === 10 || promo.bonus_rate === 12 || promo.bonus_rate === 15 || promo.bonus_rate === 20 || promo.bonus_rate === 25" :src="'/images/depo/promo/'+promo.bonus_rate+'.jpg'")
                        img(v-else :src="'assets/img/form-promo/'+(index+1)+'.png'")
                      .intro
                        .desc
                          | {{promo.promotion_name}}
                        .info
                          small {{$t('ui.deposit')}}
                          span RM{{promo.package_amount}}
                          a.iicon(href='javascript:void(0)')
                            i.fa-solid.fa-info
                  
                .nflist.epw-nflist.pointer(@click="selectPromo('', gsPayDeposit)")
                  input.radio.pointer(type='radio' v-model="promoId" value="")
                  .ccon
                    .iimg
                      img(src='images/depo/promo/no-promo.jpg')
                    .intro
                      .desc
                        | {{$tc('ui.promo_none')}}
  .mt-4.mb-4.text-center.d-flex.gap-4.justify-content-center
    button.btn-submit(type='button' @click.stop="onSubmit") {{ $t('ui.submit') }}
</template>
<script>
import config from "@/config"
import errorTags from "@/errorTags"
import { required, minLength, maxLength, sameAs, not, minValue, alphaNum} from "vuelidate/lib/validators"

export default {
  props:{
    minSettingDeposit:{
      type: Number,
      default: 0.0
    },
    operatorBankList: {
      type: Array,
      default: []
    },
    promotionList: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      bankAcc: "",
      file: "",
      imageName: "",
      message: "",
      feedback: {
        success: true,
        status: ""
      },
      filename: "",
      image_name: "",
      workingDate: this.getCurrentDate(),
      workingTime: this.getCurrentTime(),
      optionsDate: {
        format: "YYYY-MM-DD"
      },
      optionsTime: {
        format: "HH:mm"
      },
      depositAmount: "",
      referenceNo: "",
      depositMethod: "ONLINE",
      packageId:"",
      // conditionChecked: false,
      getFreeSpin:false,
      // freeSpinAmount: 0,
      // premiumSpin: false
      // euroTicket: false,
      // ticketAmount: 0,
      promoId: "",
      quickamo: 0,
    }
  },
  validations() {
    return {
      bankAcc: {
        required
      },
      depositMethod: {
        required
      },
      depositAmount: {
        required,
        // minValue: minValue(30)
        minValue: minValue(this.minSettingDeposit)
      },
      referenceNo: {
        required
        // alphaNum
      },
      imageName:{
        required
      },
      // conditionChecked:{
      //   required(val) {
      //     return val;
      //   }
      // }
    }
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    accName(){
      return config.account_name
    }
  },
  mounted() {
    // if(this.promoSelected.package_id !== '0'){
    //   this.depositAmount = this.promoSelected.package_amount;
    // }
    // if(this.defaultShow) {
    //   $('#deposit-gateway').trigger('focus')
    // }
    // var vm = this;
    // $("#modal-deposit").on("hidden.bs.modal", function() {
    //   vm.reset()
    // })
  },
  methods: {
    handleInputChange(){
      this.quickamo = 0
    },
    checkOption(e, i){
      if(this.paymentOption) {
        this.selectedOption = this.paymentOption[i].id
        this.paymentName = this.paymentOption[i].name
        this.paymentImg = this.paymentOption[i].img
        this.toggleList()
      }
      if(this.topUp.includes(this.selectedOption)){
        this.clearPromo()
      }
    },
    checkFreeSpins(amount){
      var formatNumber = Number(amount);
      if(formatNumber < 50){
        this.getFreeSpin = false;
        // this.freeSpinAmount = 0;
        // this.premiumSpin = false;
        // this.euroTicket = false;
        this.ticketAmount = 0;      
      }else{
        this.getFreeSpin = true;
        // this.euroTicket = true;
        switch(true){
          case (formatNumber >=50 && formatNumber < 100):
            // this.freeSpinAmount = 2
            // this.premiumSpin = false;
            this.ticketAmount = 1;           
          break;
          case (formatNumber >=100 && formatNumber < 200):            
            // this.freeSpinAmount = 10
            // this.premiumSpin = false;
            this.ticketAmount = 3;
          break;
          case (formatNumber >= 200 && formatNumber < 500):
            // this.freeSpinAmount = 5
            // this.premiumSpin = true;
            this.ticketAmount =7;
          break;
          case (formatNumber >= 500 && formatNumber < 1000):
            // this.freeSpinAmount = 10
            // this.premiumSpin = true;
            this.ticketAmount = 10;
          break;
          case (formatNumber >= 1000):
            // this.freeSpinAmount = 50
            // this.premiumSpin = true;
            this.ticketAmount = 13;
          break;
          default:
            // this.freeSpinAmount = 0
            // this.premiumSpin = false;
            this.ticketAmount = 0;
        }
      }
    },
    fillAmount(amount, target){
      this.quickamo = target
      this.depositAmount = amount;
      // this.checkFreeSpins(amount);
      this.clearPromo();
      this.$v.$touch()
    },
    selectPromo(id, amount){
      this.quickamo = 0
      this.promoId = id
      this.depositAmount = amount;
      this.$v.$touch()
    },
    clearPromo(){
      this.promoId = ""
    },
    reset() {
      this.bankAcc = ""
      this.file = ""
      this.message = ""
      this.filename = ""
      this.image_name = ""
      this.depositAmount = ""
      this.referenceNo = ""
      // this.depositMethod = ""
      this.packageId = ""
      this.feedback.success = true
      this.feedback.status = ""
      this.conditionChecked = false
      this.getFreeSpin = false
      this.$v.$reset()
    },
    getCurrentTime() {
      var cTime = this.$moment().format("HH:mm");
      return cTime;
    },
    getCurrentDate() {
      var cDate = this.$moment().format("YYYY-MM-DD");
      return cDate;
    },
    getFile(){
      const elem = this.$refs.file
      elem.click()
    }, 
    triggerUpload(){
      // $('input[type=file]').trigger('click');
      $('#uploadFile').trigger('click');
      
    },
    onSelect() {
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      if(this.$refs.file.files.length > 0){
        var file = this.$refs.file.files[0];
        this.imageName = this.$refs.file.files[0].name;
        this.file = file;
      }else{
        return
      }

      if (!allowedTypes.includes(file.type)) {
        this.message = this.$t("message.wrong_filetype");
      }
      if (file.size > 1000000) {
        this.message = "Too large, max size allowed is 1mb";
      }
    },
    async onSubmit() {
      if (this.imageName === "") {
        this.addDepositTicket();
      } else {
        const formData = new FormData();
        formData.append("file", this.file);
        this.loading = true;
        try {
          await this.$http
            .post("https://api.epicwincash.com/upload", formData)
            .then(function(response) {
              if (response.data.file.filename) {
                this.filename = response.data.file.filename;
              }
              this.addDepositTicket();
            });
          this.message = "Uploaded!!";
        } catch (err) {
          // console.log(err);
          // this.message = err.data.error;
          // this.loading = false;
          // this.$helpers.showDialog(this.$t("ui.attention"), err.data.error , "info", this)
          if(err.status === 0 && err.data === ""){
            this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list.disconnect"), "info", this);
          }else{
            this.message = err.data.error;
            this.loading = false;
            this.$helpers.showDialog(this.$t("ui.attention"), this.message , "info", this)
          }
        }
      }
    },
    removeAttachment(){
      document.getElementById("uploadFile").value = "";
      this.imageName = ""
      this.file = ""
    },
    addDepositTicket() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if(this.sessionToken) {
          var bankId = this.operatorBankList
            .filter(item => item.bank_acc_no === this.bankAcc)
            .map(item => item.bank_id);
          var bankHolder = this.operatorBankList
            .filter(item => item.bank_acc_no === this.bankAcc)
            .map(item => item.bank_acc_holder);

          let account_id = this.accountID
          let auth_token = this.sessionToken
          let deposit_amount = this.depositAmount
          let target_bank_id = bankId[0]
          let target_bank_acc_no = this.bankAcc
          let target_bank_acc_holder = bankHolder[0]
          let ref_no = this.referenceNo
          let attachment_path = this.filename != "" ? "https://img.epicwincash.com/" + this.filename : ""
          let deposit_date = this.workingDate + " " + this.workingTime
          let deposit_method = this.depositMethod
          let promotion_id = this.promoId
          this.loading = true
          this.$store
            .dispatch("user/addDepositTicket", { account_id, deposit_amount, target_bank_id, target_bank_acc_no, target_bank_acc_holder, ref_no, attachment_path, deposit_date, deposit_method, promotion_id, auth_token })
            .then(response => {
              this.loading = false
              this.feedback.success = response.success
              this.feedback.status = response.status
              var vm = this;
              if (this.feedback.success == true) {
                this.reset()
                this.$router.push({
                  name:"statement",
                  params:{
                    "checkTrans": true
                  }
                }).catch(error =>{})
              } else {
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(vm.$t("ui.attention"), vm.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              var vm = this;
              this.loading = false
              this.feedback.success = false
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(vm.$t("ui.attention"), vm.$t("message.list." + response.status), "info", this);
              }
              this.feedback.status = this.$t("error." + response.status)
            });
        }
      }else{
        window.scroll(0,0)
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.errspan{
  z-index: 2;
  margin: 15px 10px 0 0 !important;
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
}
</style>